/**
 * 工具类
 */
import CryptoJS from 'crypto-js';
// const charset = "utf-8";
const offset = 16;
// const algorithm = "AES";
// 加密函数
export const encryptAES = (content, key = 'NnRuSHF4Rm9kdWhCUWxBZg==',isToken=false) => {
    key = isToken?key:atob(key);
    const keyBytes = CryptoJS.enc.Utf8.parse(key);
    const iv = CryptoJS.enc.Utf8.parse(key.substring(0, offset));
    const encrypted = CryptoJS.AES.encrypt(
        content,
        keyBytes,
        {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        }
    );
    return encrypted.toString();
}

// 解密函数
export const decryptAES = (data, secretKey = 'NnRuSHF4Rm9kdWhCUWxBZg==') => {
    secretKey = atob(secretKey);
    // 将secretKey使用十六进制编码
    const keyHex = CryptoJS.enc.Utf8.parse(secretKey);
    const iv = CryptoJS.enc.Utf8.parse(secretKey.substring(0, 16)); // 向量
    // 解密数据
    const decrypted = CryptoJS.AES.decrypt(data, keyHex, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    // 返回明文
    // return decrypted;
    return decrypted.toString(CryptoJS.enc.Utf8);
}
